import {useVideoUpload} from '@features/video-upload/store.ts'
import {FetchingStep} from '@features/video-upload/components/fetching-step'
import {IdleStep} from '@features/video-upload/components/idle-step'
import {UploadedStep} from '@features/video-upload/components/uploaded-step'
import {UploadingStep} from '@features/video-upload/components/uploading-step'

export const VideoUploadModalRoot = () => {
    const step = useVideoUpload(store => store.step)

    switch (step) {
        case 'idle':
            return <IdleStep />
        case 'uploading':
            return <UploadingStep />
        case 'uploaded':
            return <UploadedStep />
        default:
            return <FetchingStep />
    }
}
